"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagCount = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
exports.TagCount = function (_a) {
    var count = _a.count;
    return count !== undefined ? react_1.default.createElement(CountSpan, null, count) : null;
};
var CountSpan = styled_components_1.default.span(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  margin-left: 0.8rem;\n  color: ", ";\n"], ["\n  margin-left: 0.8rem;\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.NTDarkGrey[600];
});
var templateObject_1;
